// Pure helpers for the cart stored in CartContext / localStorage.
// Shape: { [category]: { [materialCode]: CartItem } }

export interface CartItem {
  material_code: string;
  addons: string[];
  wheelAlignmentAddons?: string;
  qty: number;
}

export type CartState = Record<string, Record<string, CartItem>>;

// Drop categories that have no items left. A cart like { tyres: {} } has no
// products but a non-zero number of keys, which made the cart page treat it
// as non-empty.
export const pruneEmptyCategories = (cart: CartState): CartState =>
  Object.fromEntries(
    Object.entries(cart || {}).filter(
      ([, items]) =>
        !!items && typeof items === "object" && Object.keys(items).length > 0,
    ),
  );

// Total number of products across all categories (not quantities).
export const countCartItems = (cart: CartState): number =>
  Object.values(cart || {}).reduce(
    (total, items) => total + Object.keys(items || {}).length,
    0,
  );

// Copy of the cart without one product; drops the category if it is now empty.
export const withoutItem = (
  cart: CartState,
  category: string,
  materialCode: string,
): CartState =>
  pruneEmptyCategories({
    ...cart,
    [category]: Object.fromEntries(
      Object.entries(cart[category] || {}).filter(
        ([code]) => code !== materialCode,
      ),
    ),
  });
